import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      number: "01",
      title: "Sign In Securely",
      description: "Authenticate using your organization\'s SSO system for instant access without creating new credentials",
      icon: "LogIn",
      color: "primary"
    },
    {
      id: 2,
      number: "02",
      title: "Share Your Needs",
      description: "Complete a brief intake questionnaire about your current situation, preferences, and support goals",
      icon: "ClipboardList",
      color: "secondary"
    },
    {
      id: 3,
      number: "03",
      title: "Get Matched",
      description: "Our algorithm finds helpers based on availability, expertise, cultural fit, and your specific needs",
      icon: "Users",
      color: "accent"
    },
    {
      id: 4,
      number: "04",
      title: "Book & Connect",
      description: "Schedule a session at your convenience and connect via secure video, audio, or phone within minutes",
      icon: "Video",
      color: "success"
    }
  ];

  return (
    <section className="bg-background py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Getting Support is Simple
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From sign-in to your first session in under 2 minutes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps?.map((step, index) => (
            <div key={step?.id} className="relative">
              <div className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-shadow duration-200 h-full">
                <div className="flex flex-col items-center text-center">
                  <div className={`w-16 h-16 rounded-full bg-${step?.color}/10 flex items-center justify-center mb-4`}>
                    <Icon name={step?.icon} size={28} className={`text-${step?.color}`} />
                  </div>
                  
                  <div className="text-4xl font-bold text-muted-foreground/20 mb-3">
                    {step?.number}
                  </div>
                  
                  <h3 className="text-lg font-semibold text-foreground mb-3">
                    {step?.title}
                  </h3>
                  
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step?.description}
                  </p>
                </div>
              </div>

              {index < steps?.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <Icon name="ArrowRight" size={24} className="text-muted-foreground/30" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-primary/5 rounded-xl border border-primary/20 p-6">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="bg-primary/10 rounded-full p-4 flex-shrink-0">
              <Icon name="Clock" size={32} className="text-primary" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl font-semibold text-foreground mb-2">
                Average Time to First Session: 90 Seconds
              </h3>
              <p className="text-muted-foreground">
                Most users connect with a helper within 2 minutes of signing in. No waiting lists, no lengthy intake processes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;